import { COMPANY_PRIVACY_POLICY_URL, COMPANY_TERMS_URL } from '@/constants/company';
import Link from 'next/link';
import { Fragment } from 'react';
const legalLinks = [{
  label: 'Terms of use',
  href: COMPANY_TERMS_URL
}, {
  label: 'Privacy policy',
  href: COMPANY_PRIVACY_POLICY_URL
}];
export const LegalLinks = () => <div className="flex items-center gap-2 md:items-stretch md:gap-10" data-sentry-component="LegalLinks" data-sentry-source-file="LegalLinks.tsx">
    {legalLinks.map((link, index) => <Fragment key={link.href}>
        {index !== 0 && <span className="font-semibold text-gray-950 text-sm md:hidden dark:text-white">
            •
          </span>}
        <Link className="font-sans font-semibold text-base text-gray-950 md:text-sm xl:text-xs 2xl:text-sm dark:text-white" href={link.href}>
          {link.label}
        </Link>
      </Fragment>)}
  </div>;